<template>
    <div class="login">
        <div class="header clearfix">
            <router-link class="fl" to="/index"><img src="~@/assets/imgs/Group10.png" alt="logo"></router-link>
            <router-link class="fr" to="/index">返回网站首页>></router-link>
        </div>
        <div class="content">
            <div class="content_login">
                <p class="title"><span class="active">请选择注册账号类型</span></p>
                <div class="msg clearfix">
                    <div class="fl">
                        <img src="~@/assets/imgs/Oval1.png" alt="科研人才网-高校中高层管理人才引进">
                        <p>个人用户</p>
                        <ul>
                            <li><img src="~@/assets/imgs/hook.png" alt="科研人才网-硕士博士科研专项人才引进"><span>免费创简历</span></li>
                            <li><img src="~@/assets/imgs/hook.png" alt="科研人才网-事业单位硕士博士人才招聘"><span>职位海量淘</span></li>
                            <li><img src="~@/assets/imgs/hook.png" alt="科研人才网-事业单位硕士博士科研人才招聘"><span>简历轻松投</span></li>
                        </ul>
                    </div>
                    <div class="fl">
                        <img src="~@/assets/imgs/Oval2.png" alt="科研人才网-高校学术带头人引进">
                        <p>单位用户</p>
                        <ul>
                            <li><img src="~@/assets/imgs/hook.png" alt="科研人才网-高校学术带头人引进"><span>发布招聘信息</span></li>
                            <li><img src="~@/assets/imgs/hook.png" alt="科研人才网-高级科研人才引进"><span>收取简历投递</span></li>
                            <li><img src="~@/assets/imgs/hook.png" alt="科研人才网-高校中高层管理人才引进"><span>多种职位分享</span></li>
                        </ul>
                    </div>
                    <p class="checkToregister fl"><span @click="toRegister(true)">立即注册</span><span @click="toRegister(false)">立即注册</span></p>
                </div>
            </div>
        </div>
        <div class="footer clearfix">
            <div class="models fl clearfix">
                <img class="fl" src="~@/assets/imgs/strong.png" alt="科研人才网-国外名校博后/研究员招聘">
                <h3>强大的招聘平台</h3>
                <p>提供快捷、高效、可靠的网上招聘</p>
            </div>
            <div class="models fl clearfix">
                <img class="fl" src="~@/assets/imgs/opportunity.png" alt="科研人才网-海归硕士人才引进">
                <h3>强大的招聘平台</h3>
                <p>提供快捷、高效、可靠的网上招聘</p>
            </div>
            <div class="models fl clearfix">
                <img class="fl" src="~@/assets/imgs/Group.png" alt="科研人才网-海归博士人才引进">
                <h3>强大的招聘平台</h3>
                <p>提供快捷、高效、可靠的网上招聘</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'selectRegister',
    data () {
        return {
        }
    },
    methods:{
        toRegister(flags){
            this.$router.push({path:'/login',query:{'loginFlag':flags}});
        }
    }
}
</script>
<style scoped = "scoped"  lang = "less">
.login{
    background-color: white;
    .header{
        width: 1200px;
        margin: 0 auto;
        height: 105px;
        line-height: 105px;
        .fl{
            margin-top: 24px;
        }
        .fr{
            font-size:16px;
            font-family:PingFangSC-Semibold;
            font-weight:600;
            color:rgba(23,135,251,1);
        }
    }
    .content{
        width: 100%;
        height: 530px;
        background: url("~@/assets/imgs/loginBg.png") no-repeat center center;
        position: relative;
        .content_login{
            background-color: white;
            width: 390px;
            height: 432px;
            position: absolute;
            top: 50px;
            left: 50%;
            margin-left: 180px;
            padding: 30px 35px 35px;
            .title{
                color:rgba(102,102,102,1);
                span{
                    display: inline-block;
                    width: 100%;
                    text-align: center;
                    font-size:20px;
                    font-family:PingFangSC-Regular;
                    font-weight:400;
                    cursor: pointer;
                }
                .active{
                    color: #1787FB;
                }
            }
            .msg{
                margin-top: 30px;
                .fl{
                    width: 49%;
                    height: 230px;
                    text-align: center;
                    p{
                        color: #1787FB;
                        height:20px;
                        font-size:16px;
                        font-family:Helvetica;
                        line-height:20px;
                        margin-top: 10px;
                    }
                    ul{
                        margin-top: 20px;
                        li{
                            height:20px;
                            font-size:16px;
                            font-family:PingFangSC-Regular;
                            font-weight:400;
                            color:rgba(102,102,102,1);
                            line-height:20px;
                            margin-bottom: 10px;
                        }
                    }
                }
                .fl:first-child{
                    border-right: 1px solid #E5E5E5;
                }
                .checkToregister{
                    margin-top: 30px;
                    height: 46px;
                    line-height: 46px;
                    text-align: center;
                    width: 100%;
                    span{
                        display: inline-block;
                        width: 140px;
                        height: 46px;
                        color: #1787FB;
                        border:1px solid #1787FB;
                        border-radius: 4px;
                        cursor: pointer;
                        text-align: center;
                    }
                    span:last-child{
                        margin-left: 38px;
                    }
                }
            }
        }
    }
    .footer{
        width: 1200px;
        margin: 60px auto 80px;
        .models{
            width: 33.3%;
            height: 58px;
            img{
                height: 58px;
                margin-right: 10px;
            }
            h3{
                height:25px;
                font-size:18px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:25px;
            }
            p{
                height:20px;
                font-size:14px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:20px;
                margin-top: 10px;
            }
        }
    }
}
@media all and (max-width: 768px) {
    .login{
        .header{
            width: 100%;
        }
        .content{
            .content_login{
                width: 80%;
                left: 0;
                margin-left: 10%;
                height: 462px;
                top: 20px;
                .msg{
                    .checkToregister{
                        span{
                            width: 40%;
                        }
                    }
                    .fl{
                        ul{
                            li{
                                font-size: 14px;
                            }
                        }
                    }
                }
            }
        }
        .footer{
            width: 100%;
            margin: 30px auto 30px;
            .models{
                width: 100%;
                margin-top: 16px;
                padding-left: 20px; 
            }
        }
        .footerBottom{
            .footer_top{
                height: 76px;
                line-height: 36px;
            }
            .footer_bottom{
                height: 250px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/login/select_register.vue